export const ClientTemplatesRoute = {
  id: "clientTemplates",
  titleKey: "clientCard.templates",
  path: "/client/:id/invoices/templates",
};

export const InvoiceValidationRoute = {
  id: "invoiceValidation",
  titleKey: "menu.invoiceValidation",
  path: "/invoices/validate",
};
export const InvoiceAssessmentRoute = {
  id: "invoiceAssessment",
  titleKey: "menu.invoiceAssessment",
  path: "/invoices/assess",
};

export const InvoicesListRoute = {
  id: "invoicesList",
  titleKey: "clientCard.invoices",
  path: "/invoices/alls",
};
export const InvoicesDoneRoute = {
  id: "invoicesDone",
  titleKey: "invoices.done",
  path: "/invoices/done",
};
export const GroupsRoute = {
  id: "groups",
  titleKey: "users.groups",
  path: "/groups",
};

export const routes = [
  ClientTemplatesRoute,
  InvoiceValidationRoute,
  InvoiceAssessmentRoute,
  InvoicesListRoute,
  InvoicesDoneRoute,
  GroupsRoute,
];
